import React, { Component } from 'react';
import { FacebookIcon, InstagramIcon, MessageCircleIcon, TwitterIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
export function ShareSection() {
  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(CHECKOUT_URL)}`,
    instagram: 'https://www.instagram.com/',
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent('I found this baby protocol that is helping me so much with sleep and development. ' + CHECKOUT_URL)}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent("I found the protocol I needed for my baby's first year. Sleep, stimulation, and nutrition in a single system. " + CHECKOUT_URL)}`
  };
  return <section className="bg-gradient-to-br from-[#FAF7F2] to-[#F0E8DE] py-16 px-5 text-center" data-id="element-238">
      <div className="max-w-[900px] mx-auto" data-id="element-239">
        <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 font-sans font-bold" data-id="element-240">
          Share the love
        </span>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-3" data-id="element-241">
          Do you know someone going through this?
        </h2>

        <p className="text-base text-[#6B4C3B] font-sans mb-9" data-id="element-242">
          If you think this can help someone you love,
          <br data-id="element-243" />
          share it here. Your gesture can change another baby's first year.
        </p>

        <div className="flex justify-center flex-wrap gap-4" data-id="element-244">
          <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 px-6 py-3.5 rounded-full text-sm font-bold font-sans transition-all hover:-translate-y-1 hover:opacity-90 text-white bg-[#1877F2]" data-id="element-245">
            <FacebookIcon size={20} data-id="element-246" />
            Facebook
          </a>

          <a href={shareLinks.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 px-6 py-3.5 rounded-full text-sm font-bold font-sans transition-all hover:-translate-y-1 hover:opacity-90 text-white bg-gradient-to-r from-[#f09433] via-[#dc2743] to-[#bc1888]" data-id="element-247">
            <InstagramIcon size={20} data-id="element-248" />
            Instagram
          </a>

          <a href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 px-6 py-3.5 rounded-full text-sm font-bold font-sans transition-all hover:-translate-y-1 hover:opacity-90 text-white bg-[#25D366]" data-id="element-249">
            <MessageCircleIcon size={20} data-id="element-250" />
            WhatsApp
          </a>

          <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 px-6 py-3.5 rounded-full text-sm font-bold font-sans transition-all hover:-translate-y-1 hover:opacity-90 text-white bg-black" data-id="element-251">
            <TwitterIcon size={20} data-id="element-252" />X (Twitter)
          </a>
        </div>
      </div>
    </section>;
}